import React, { Component } from 'react';
import ParameterErrors from '../../errors/ParameterErrors';
import ParameterError from '../../errors/ParameterError';
const{throwNotProvided}=ParameterErrors;
export default class TabPanel_Panel extends Component {
	constructor(props){
		super(props);
		const {active}=props;
		this.state = {active:active?true:false};
		this._child = props.children;
		if(this._child===undefined||this._child===null)
			throwNotProvided('single children entry');
		if(Array.isArray(this._child))
			throw ParameterError('Only one child is accepted');
	}
	get tabInfo(){
		return this._tabInfo;
	}
	set active(value){
		this.setState({active:value});
	}
	componentDidMount(){
		const tabInfo = this.props.children.ref.current.tabInfo;
		this.setState({tabInfo:tabInfo});
		this._tabInfo = tabInfo;
	}
	render() {
		let className = "tab-panel-panel";
		if(this.state.active)
			className+=" active";
		return (<div className={className}>
			{this.props.children}
				</div>)
	}
}
